import { Dialog } from "@headlessui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { FormBox, ModalFoterBox } from "../../../components/box/Box";
import Button from "../../../components/button/Button";
import FormController from "../../../components/fields/FormController";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { OnlineUrls, onlineUrlsSchema } from "../../../model/OnlineUrls";
import { TextField } from "../../../components/fields/Fields";
import { ConstMessage } from "../../../config/const";

export type OnlineUrlsSettingModalProp = {
  onlineUrl?: OnlineUrls;
  authorUid: string;
  onSubmit: (data: OnlineUrls) => Promise<void>;
}

export const OnlineUrlSettingModal = ({
  open,
  toggle,
  closeOnClickOutside,
  updateFlg,
  onlineUrl,
  authorUid,
  onSubmit,
}: ModalProp & OnlineUrlsSettingModalProp) => {
  const { control, handleSubmit, reset, setValue, watch } =
    useForm<OnlineUrls>({
      resolver: yupResolver(onlineUrlsSchema),
      defaultValues: onlineUrl,
    });

  useEffect(() => {
    if(updateFlg) {
      setValue('id', onlineUrl?.id ?? '');
      setValue('name', onlineUrl?.name ?? '');
      setValue('url', onlineUrl?.url ?? 'https://');
      setValue('type', onlineUrl?.type ?? '');
      setValue('createUser', authorUid);
      setValue('createAt', onlineUrl?.createAt ?? new Date());
      // 重複チェック初期化
      sessionStorage.removeItem("dupCheck");
    }
  },[onlineUrl, setValue, updateFlg, authorUid]);

  useEffect(() => {
    if(!open) {
      reset();
    };
  },[open, reset]);

  // ミーティングURL名称変更時
  useEffect(() => {
    // dupCheckをリセット(false)
    sessionStorage.setItem("dupCheck", "false");
    // 入力値更新
    setValue("name",watch("name"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("name")]);
  
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <form
            className=""
            onSubmit={handleSubmit(onSubmit)}
          >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                ミーティングURL設定
              </Dialog.Title>
              <div className="overflow-y-auto">
                <div className="px-2 text-left pb-8 h-[500px] ">
                  <FormBox className="flex">
                  <Controller
                      name={"name"}
                      control={control}
                      render={({ field, fieldState }) => (
                        <TextField
                          {...field}
                          type={"text"}
                          label={"名称"}
                          required
                          error={fieldState.error || sessionStorage.getItem("dupCheck") === "true"}
                          helperText={fieldState.error?.message || (sessionStorage.getItem("dupCheck") === "true" ? ConstMessage.ERR_ONLINE_URLS_DUPLICATION : "")}
                        />
                      )}
                    />
                  </FormBox>
                  <FormController
                    control={control}
                    name={"url"}
                    label={"URL"}
                    type={"text"}
                    required
                    />
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              submit
              children={"登録"}
            />
          </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  )
}